import { Api } from '@/services/Api';

export default {
    /*  1. Get all data */
    getGroups(keyword = '') {
        return Api().get(`/Group${keyword ? '?Keyword=' + keyword : ''}`);
    },

     /*  2. Get one column */
    getGroup(id) {
        return Api().get(`/Group/${id}`);
    },

     /*  3. Create one column */
    saveGroup(body) {
        return Api().post(`/Group`, body);
    },

    /*  4. Delete one or more columns */
    deleteGroups(groups) {
        return Api().post(`/Group/DeleteGroup`, groups);
    },

    /*  5. post one or more columns */
    postGroups(groups) { 
        return Api().post(`/Group/PostGroup`, groups);
    }
}